// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__cCLK7","helpMeBtn":"styles_helpMeBtn__2Xitd","slideInSearchBar":"styles_slideInSearchBar__lEjXG"};